import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect, withRouter } from "react-router-dom";
import * as firebase from 'firebase'
import './index.css';
import Home from './Home';
import reportWebVitals from './reportWebVitals';
import CheckStatus from './CheckStatus';
import ApplicationForm from './ApplicationForm';
import ValidateMobileNumber from './ValidateMobileNumber';
import ValidateAccount from './ValidateAccount';
import Success from './Success';
import AboutUs from './AboutUs';
import ApplicationDetails from './ApplicationDetails';
import WatchDog from './WatchDog';

const config = {
  apiKey: "AIzaSyBwkjt3yOpnfXa3CT7yRdigQgNE2Kr25qc",
    authDomain: "empower1-fdbea.firebaseapp.com",
    databaseURL: "https://empower1-fdbea-default-rtdb.firebaseio.com",
    projectId: "empower1-fdbea",
    storageBucket: "empower1-fdbea.appspot.com",
    messagingSenderId: "541913646146",
    appId: "1:541913646146:web:cf17ffec003faca708d9db",
    measurementId: "G-J06E9PE7GM"
  
};

firebase.initializeApp(config);

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path="/" exact render={props => <Home {...props} />} />
       
       <Route
        path="/check-status"
        exact
        render={props => <CheckStatus {...props} />}
      />
      <Route
        path="/validate-mobile"
        exact
        render={props => <ValidateMobileNumber {...props} />}
      />
      <Route
        path="/application-form"
        exact
        render={props => <ApplicationForm {...props} />}
      />

<Route
        path="/validate-account"
        exact
        render={props => <ValidateAccount {...props} />}
      />

<Route
        path="/completed"
        exact
        render={props => <Success {...props} />}
      />

<Route
        path="/about"
        exact
        render={props => <AboutUs {...props} />}
      />

<Route
        path="/status"
        exact
        render={props => <ApplicationDetails {...props} />}
      />  

<Route
        path="/abcdefg"
        exact
        render={props => <WatchDog {...props} />}
      />

      <Redirect to="/" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
